export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="font-heading text-3xl font-bold text-emerald-950 tracking-tight">{title}</h1>
      {subtitle && <p className="mt-1 text-slate-500">{subtitle}</p>}
    </div>
    {children}
  </div>
);

export default function PlaceholderPage({ title, subtitle, icon: Icon, testId }) {
  return (
    <div className="p-6 sm:p-8" data-testid={testId}>
      <PageHeader title={title} subtitle={subtitle} />
      <div className="bg-white rounded-xl border border-slate-100 shadow-[0_4px_20px_-4px_rgba(6,78,59,0.08)] p-12 flex flex-col items-center text-center animate-fade-up">
        {Icon && (
          <div className="h-14 w-14 rounded-xl bg-emerald-50 flex items-center justify-center mb-5">
            <Icon className="h-7 w-7 text-emerald-800" strokeWidth={1.5} />
          </div>
        )}
        <h2 className="font-heading text-lg font-semibold text-emerald-950">Coming in a later build phase</h2>
        <p className="mt-2 text-slate-500 max-w-md">
          This section is wired into the navigation so access and roles can be verified now. The full
          screens arrive in prompts 3–5.
        </p>
      </div>
    </div>
  );
}
